export const FETCHING_TRANSACTION_SUMMARY = 'FETCHING_TRANSACTION_SUMMARY';
export const FETCH_TRANSACTION_SUMMARY_SUCCESS = 'FETCHING_TRANSACTION_SUMMARY_SUCCESS';



// WEBPACK FOOTER //
// ./src/redux/transactionSummary/TransactionSummaryConstants.js